
				var addMethods = require("../../../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["addInlineMediaAtEndWorker","addAudioVideoTimeWorker","addImageTimeWorker","createAndCopyDocTimeWorker","createClippedDocWorker","createClippedDocFromLocationWorker","createAndCopyDocLocationWorker"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "933ea03bdaf2a8f68cbd.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			